import { render, staticRenderFns } from "./add-video.vue?vue&type=template&id=3abe5f5e&scoped=true&"
import script from "./add-video.vue?vue&type=script&lang=js&"
export * from "./add-video.vue?vue&type=script&lang=js&"
import style0 from "./add-video.vue?vue&type=style&index=0&id=3abe5f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe5f5e",
  null
  
)

export default component.exports